// Kabari server bahwa aplikasi dibuka (sekali per halaman dimuat), untuk statistik
// kunjungan di halaman admin. Tidak mengirim nama atau isi apa pun; gagal = diam.
import { MODE_DEMO } from './riwayat.js';

export function catatKunjungan() {
  if (MODE_DEMO || !navigator.onLine) return;
  const terpasang = matchMedia('(display-mode: standalone)').matches || navigator.standalone === true;
  const sisiPendek = Math.min(screen.width, screen.height);
  const layar = sisiPendek < 600 ? 'hp' : navigator.maxTouchPoints > 1 ? 'tablet' : 'desktop';
  fetch('/api/hit', {
    method: 'POST',
    credentials: 'same-origin',
    keepalive: true,
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ mode: terpasang ? 'terpasang' : 'browser', layar }),
  }).catch(() => {});
}
